import baseUrlConfig from '../config/baseUrl.json';

export function isAbsoluteUrl(url) {
  return /^https?:/i.test(`${url}`);
}

export function getApiBaseUrl(url, environment = 'QA', proxy = false) {
  if (isAbsoluteUrl(url) || proxy) {
    return url;
  }
  const apiEnv = environment.toUpperCase().split('-')[0];
  const apiBaseUrl = baseUrlConfig[apiEnv] && baseUrlConfig[apiEnv].apiUrl;
  return `${apiBaseUrl}${url}`;
}
